// extracted by mini-css-extract-plugin
module.exports = {"section_hero":"hero_section_hero__gLP5Z","title":"hero_title__7YH_A","font_thin":"hero_font_thin__kJ_KZ","btn_wrapper":"hero_btn_wrapper__eGtQX"};